import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PlayFilledSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1143 6.53092L10.736 4.30911C7.68954 2.76319 6.16632 1.99023 5.08316 2.86968C4 3.74912 4 5.75881 4 9.77818V14.2218C4 18.2412 4 20.2509 5.08316 21.1303C6.16632 22.0098 7.68954 21.2368 10.736 19.6909L15.1144 17.4691C19.7048 15.1397 22 13.9749 22 12C22 10.0251 19.7048 8.86034 15.1143 6.53092Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const PlayFilledSize24 = hoc(forwardRef(PlayFilledSize24Component), 'PlayFilledSize24');

export { PlayFilledSize24 as default };
//# sourceMappingURL=PlayFilledSize24.js.map
